/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Site-group list, editor, and analysis pages.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {ReportWidgetsModule} from '../report/report-widgets.module';
import {SiteGroupEditPageComponent} from './site-group-edit-page.component';
import {SiteGroupAnalysisPageComponent} from './site-group-analysis-page.component';
import {SiteGroupListPageComponent} from './site-group-list-page.component';

const SITE_GROUP = [
  SiteGroupEditPageComponent,
  SiteGroupAnalysisPageComponent,
  SiteGroupListPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    FormControlsModule,
    ReportWidgetsModule
  ],
  declarations: SITE_GROUP,
  exports: SITE_GROUP
})
export class SiteGroupModule {
}
